









import Modal from '@/components/mixins/Modal';

import LoadingCircle from '@/components/LoadingCircle.vue';
import MarkdownContent from '@/components/MarkdownContent.vue';

export default Modal.extend({
    components: {
        LoadingCircle,
        MarkdownContent,
    },
    props: {
        message: {
            type: String,
            default: 'Loading...',
        },
    },
});
